import camelCaseObjectDeep from "camelcase-object-deep";
export var convertToCamelCase = function (object) {
    return camelCaseObjectDeep(object);
};
